export const noEditableNewObservationVisible = [
  'documento',
  'iup'
];
